import React from 'react';

interface ResultsHeaderProps {
  totalCount: number;
  from: number;
  to: number;
}

const ResultsHeader: React.FC<ResultsHeaderProps> = ({ totalCount, from, to }) => {
  return (
    <div className="mb-4">
      <h4 className="mb-1 fw-bold">あなたにピッタリのフリーランス案件が見つかる</h4>
      {totalCount > 0 && (
        <p className="text-muted mb-0">
          {from}〜{to}件目 / 全{totalCount.toLocaleString()}件
        </p>
      )}
    </div>
  );
};

export default ResultsHeader;
